<soft-field-ok
  fieldOkName="ktostamm.kunde.subnummer"
  [placeholder]="placeholder() ?? 'Subnummer'"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)"
/>
